import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DynamicLocaleService } from '../../../dynamic-locale.service';
import { GroupBase } from '../../../models/blueprint.model';
import {
  GroupedDataRecordModel,
  RecordUpdateEmission,
  ReportOptions,
  ReportView,
  TemplateProjectionMap,
} from '../../../models/report.model';
import { TemplateField, ViewTemplateCatalog } from '../../../models/template.model';
import { IMAGE_FIELD_ID } from '../../../shared';
import { EditableFieldsService } from '../../editable-fields.service';

@Component({
  selector: 'rep-condensed-body',
  templateUrl: './condensed-body.component.html',
  styleUrls: ['./condensed-body.component.scss'],
  standalone: false,
})
export class CondensedBodyComponent implements OnChanges {
  @Input() entity: string;
  @Input() reportRecordData: GroupedDataRecordModel;
  @Input() allRecords: GroupedDataRecordModel[];
  @Input() bodyGroups: GroupBase<TemplateField>[];
  @Input() footerGroups: GroupBase<TemplateField>[];
  @Input() currentView: ReportView;
  @Input() templateProjectionMap: TemplateProjectionMap;
  @Input() reportOptions: ReportOptions;
  @Input() isPDF: boolean;
  @Input() templateFieldsCatalog: ViewTemplateCatalog;

  @Output() removeRecord: EventEmitter<any> = new EventEmitter<any>();
  @Output() reportUpdateClick: EventEmitter<RecordUpdateEmission> = new EventEmitter<RecordUpdateEmission>();
  public imageField: TemplateField;

  constructor(
    public editableFieldsService: EditableFieldsService,
    private dynamicLocaleService: DynamicLocaleService
  ) {}

  ngOnChanges(_changes: SimpleChanges): void {
    this.editableFieldsService.mapEditableFields(this.bodyGroups);
    this.editableFieldsService.mapEditableFields(this.footerGroups);
    const bodyFields: TemplateField[] = this.bodyGroups.reduce((acc, group) => [...acc, ...group.fields], []) || [];
    this.bodyGroups = this.bodyGroups.filter(group => !group.fields.some(field => field.id === IMAGE_FIELD_ID));
    this.imageField = bodyFields.find(field => field.id === IMAGE_FIELD_ID);
    // hide broker or agency on check in report options
    this.hideBrokerOnCheck();
  }

  emitEditableFields(event: MouseEvent, id: number) {
    const emittedObject = this.editableFieldsService.generateRecordUpdateEmission(
      event,
      id,
      this.reportRecordData.data[0]
    );
    if (emittedObject != null) {
      emittedObject.locale = this.dynamicLocaleService.reportLocale;
      this.reportUpdateClick.emit(emittedObject);
    }
  }

  private hideBrokerOnCheck() {
    const { brokerAgency } = this.reportOptions;
    if (brokerAgency) {
      this.bodyGroups = this.bodyGroups.filter(group => !group.specialCase);
    }
  }
}
